
global.year = 2018
global.nat = "France"
global.ag = ''
global.ar = ''
global.name_area = ''
global.name_ag = ''
global.menu = 1;

//Neo4Tourism

global.title = "e-Khonsou";

global.ar1 = {
  ar: "Area1",
  ag: "Area2",
  name_area: "Hauts-de-France",
  double : 0,
  zoom : 7,
  center : [0, 0]
}
global.ar2 = {
  ar: "Area2",
  ag: "Area3",
  name_area: "Nord",
  zoom : 8,
  center : [0, 0]
}
global.ar3 = {
  ar: "Area3",
  ag: "Area4",
  name_area: "Lille",
  zoom : 10,
  center : [0, 0]
}

global.shapes2 = require('./Resources/Shapes/Area2.json')
global.shapes3 = require('./Resources/Shapes/Area3.json')
global.shapes4 = require('./Resources/Shapes/Area4.json')
global.shapes2 = global.shapes2.features
global.shapes3 = global.shapes3.features
global.shapes4 = global.shapes4.features

global.shapes = { Area2: global.shapes2, Area3: global.shapes3, Area4: global.shapes4 }
global.center = [44.704861, -0]



global.color1 = [78, 255, 232, 1]
global.color2 = [25, 19, 129, 1]

global.min = 0.15
global.max = 1.85

global.grad = []
global.size = 500
for (let i = 1; i <= global.size; i++) {
    var ibis = i / global.size;
    var r = parseInt(ibis * (global.color2[0] - global.color1[0]) + global.color1[0])
    var g = parseInt(ibis * (global.color2[1] - global.color1[1]) + global.color1[1])
    var b = parseInt(ibis * (global.color2[2] - global.color1[2]) + global.color1[2])
    global.grad[i - 1] = { r, g, b }
}


export function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}

export function rgbToHex(color) {
    return "#" + componentToHex(color.r) + componentToHex(color.g) + componentToHex(color.b);
}

export function Scale(value) {
    var result = (value - global.min) / (global.max - global.min)
    if (result > 1) result = 1
    if (result < 0) result = 0
    return result
}

export function GetColor(TCF) {
    var result = '#888888'
    var index = parseInt(global.size * Scale(TCF))
    if (index === global.size) index = global.size - 1
    result = (rgbToHex(global.grad[index]))

    return result
}

global.optionsYE = [
  { value: 2018, label: '2018' },
  { value: 2017, label: '2017' },
  { value: 2016, label: '2016' },
  { value: 2015, label: '2015' },
  { value: 2014, label: '2014' },
  { value: 2013, label: '2013' },
]
global.optionsNT = [
    { value: 'France', label: 'France' },
    { value: 'United Kingdom', label: 'United Kingdom' },
    { value: 'United States', label: 'United States' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Spain', label: 'Spain' },
    { value: 'Germany', label: 'Germany' },
    { value: 'Switzerland', label: 'Switzerland' }
]

//Booking

global.shapeGID = 52094;
global.nbShapes = 1;
